import { selectProviders } from '@modules/admin/Admin.Dux'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { compose } from 'redux'
import './MultiSelect.scss'
import SelectField from './SelectField'

class SelectProviderField extends Component {
  static defaultProps = {
    providers: [],
  }

  render() {
    const { providers, placeholder, multi, t } = this.props
    return (
      <SelectField
        {...this.props}
        placeholder={placeholder || `${multi ? t('Proveedores') : t('Proveedor')}`}
        options={providers}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  providers: selectProviders(state),
})

export default compose(withTranslation(), connect(mapStateToProps))(SelectProviderField)
